var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTurnDeviceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.78,
    height: 128.279,
    viewBox: "0 0 140.78 128.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73089",
    "data-name": "Group 73089",
    transform: "translate(-4558.093 -512.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73087",
    "data-name": "Group 73087",
    transform: "translate(4559.093 500.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-rotate-90-degrees-ccw",
    "data-name": "Icon material-rotate-90-degrees-ccw",
    d: "M6.379,14.208A21.624,21.624,0,0,1,21.747,7.829V0L31.993,10.245,21.747,20.491V12.662A16.915,16.915,0,0,0,9.786,41.537a2.413,2.413,0,0,1-3.407,3.407,21.7,21.7,0,0,1,0-30.736Z",
    transform: "translate(28.762 12.056) rotate(13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-phone-iphone",
    "data-name": "Icon material-phone-iphone",
    d: "M67,1.5H21.666A14.171,14.171,0,0,0,7.5,15.666v96.327a14.171,14.171,0,0,0,14.166,14.166H67a14.171,14.171,0,0,0,14.166-14.166V15.666A14.171,14.171,0,0,0,67,1.5ZM44.331,120.493a8.5,8.5,0,1,1,8.5-8.5A8.488,8.488,0,0,1,44.331,120.493Zm25.5-22.665h-51V18.5h51Z",
    transform: "translate(58.617 13.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_10",
    "data-name": "Subtraction 10",
    d: "M76.178,73.663H14.166A14.182,14.182,0,0,1,0,59.5V14.167A14.182,14.182,0,0,1,14.166,0h61.7V11.334H17v51H75.868V72.456a2.5,2.5,0,0,0,.309,1.205h0Z",
    transform: "translate(0 65.671)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "9 3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnDeviceIcon);
export default __webpack_public_path__ + "static/media/turn_device_icon.3078a717a2b2cd68a7b698b24c17e1b9.svg";
export { ForwardRef as ReactComponent };